import { render } from "./ExtraCoursesProfile.vue?vue&type=template&id=97ae22be"
import script from "./ExtraCoursesProfile.vue?vue&type=script&lang=js"
export * from "./ExtraCoursesProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__